import { Children, cloneElement, PropsWithChildren, ReactElement, useEffect, useRef } from 'react';

import { TimesIcon } from '../../../../assets/svg';
import { RightIcon } from '../../../../assets/svg/RightIcon';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import {
	ContainerIcon,
	ModalBody,
	ModalBodyWrapper,
	ModalContainer,
	ModalContent,
	ModalHeader,
	ModalSubTitle,
	ModalSubTitleContainer,
	ModalTextContainer,
	ModalTitle,
	PositionTypeProps,
	TimesContainer,
} from './styles';

export type TypeAllowed = 'small' | 'medium' | 'large' | 'xl-large';
export type VariantAllowed = 'one-layout' | 'two-layout';

interface ModalProps {
	title: string;
	subTitle?: string;
	show: boolean;
	type?: TypeAllowed;
	variant?: VariantAllowed;
	allowCloseModal?: boolean;
	allowClickOutside?: boolean;
	onClose: () => void;
	children: ReactElement | ReactElement[];
	positionType: PositionTypeProps;
}

const CustomPaymentLinksModal = ({
	title,
	subTitle,
	show,
	type = 'small',
	allowCloseModal = true,
	allowClickOutside = true,
	onClose,
	children,
	positionType,
}: PropsWithChildren<ModalProps>) => {
	const arrayChildren = Children.toArray(children);
	const modal = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (show) document.body.style.overflow = 'hidden';
		else document.body.style.overflow = 'auto';
	}, [show]);

	if (allowClickOutside) useClickOutside({ elementRef: modal, callback: () => onClose() });

	return (
		<ModalContainer>
			<ModalContent ref={modal} show={show} type={type} positionType={positionType}>
				<ModalHeader>
					<ModalTextContainer>
						<ModalSubTitleContainer>
							<ModalSubTitle>{subTitle}</ModalSubTitle>
							<ContainerIcon>
								<RightIcon />
							</ContainerIcon>
						</ModalSubTitleContainer>
						<ModalTitle>{title}</ModalTitle>
					</ModalTextContainer>

					{allowCloseModal && (
						<TimesContainer onClick={() => onClose()}>
							<TimesIcon />
						</TimesContainer>
					)}
				</ModalHeader>

				<ModalBody>
					{Children.map(arrayChildren, (child) => {
						const childElement = child as ReactElement;
						return (
							<ModalBodyWrapper>
								{cloneElement(childElement, { ...childElement.props })}
							</ModalBodyWrapper>
						);
					})}
				</ModalBody>
			</ModalContent>
		</ModalContainer>
	);
};

export { CustomPaymentLinksModal };
